module.exports = __webpack_public_path__ + "media/customizations/amblebrook/logo-17ae6fee052cd517f2f50e4811e47f83.png";